import React, { useCallback, useMemo } from 'react';
import { useListClientsQuery } from '../../../../API/clients/ClientCompanyApi';
import { nameComparator } from '../../../../utilities/labelComparator';
import { useField } from 'formik';
import { UUID } from '../../../../types/shared/UUID';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';

const useListClientCompanyOptions = () => {
  const { data = [] } = useListClientsQuery({ includeDeactivated: true });
  return useMemo(() => {
    return data.toSorted(nameComparator).map(({ id, name }) => ({ id: id, label: name, value: id }));
  }, [data]);
};

export const ClientCompaniesFilter: React.FC = () => {
  const [field, meta, helpers] = useField<UUID[]>({ name: 'clientCompanies' });
  const sortedClientCompanies = useListClientCompanyOptions();

  const onChange = useCallback(
    (nextValue: any) => {
      helpers.setValue(nextValue);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Client</Label>}
      control={
        <Combobox
          value={field.value}
          options={sortedClientCompanies}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          multiple
          limitTagsShown={3}
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
